import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '20px',
        border: isHosTheme
            ? `0.5px solid ${theme.palette.secondary.dark}`
            : `1px solid ${theme.palette.grey[600]}`,
        borderRadius: isHosTheme ? theme.custom.borderRadius[23] : 0,
        ...(isHosTheme && {
            backgroundColor: theme.palette.common.white,
        }),
    }),

    button: css({
        marginTop: '16px',
        width: '100%',
        borderRadius: '100px',
        padding: '12px',
        textTransform: 'uppercase',
    }),

    header: css({
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        marginBottom: '12px',
    }),
};
